import type { IconData } from '@stacksjs/iconify-core'

export const healthTransfusionBag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.435 12.19h1.52v16.77h-1.52Zm-1.53 16.77h1.53v1.52h-1.53Zm0-18.29h1.53v1.52h-1.53Zm-1.52-1.52h1.52v1.52h-1.52ZM6.095 30.48h19.81V32H6.095Zm1.53-3.05h1.52v1.53h13.71v-1.53h1.53v-1.52h1.52V15.24H6.1v10.67h1.53Zm1.52-9.14h13.71v7.62H9.145Zm15.24-9.14V7.62h-1.53V4.57h1.53V3.05h-4.57v1.52h1.52v3.05h-1.52v1.53z\"/><path fill=\"currentColor\" d=\"M10.665 22.86h10.67v1.52h-10.67Zm0-3.05h10.67v1.53h-10.67Zm7.62-13.71h1.53v1.52h-1.53Zm0 0V4.57h-1.52V0h-1.52v4.57h-1.53V6.1zm-6.09 0h1.52v1.52h-1.52Zm0 3.05V7.62h-1.53V4.57h1.53V3.05h-4.57v1.52h1.52v3.05h-1.52v1.53zm-6.1 0h1.53v1.52h-1.53Zm-1.52 19.81h1.52v1.52h-1.52Zm0-18.29h1.52v1.52h-1.52Zm-1.53 1.52h1.53v16.77h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default healthTransfusionBag
